import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { Section } from 'common';
import strings from 'strings';
import { filterValidItems, isTruthyValue } from 'utils';

import { DescriptionText } from '../../styles';
import { formatMonthYear } from '../../utils';

const COPIES = strings.candidates.profile.resumeTab.sections.certifications;

export const Certifications = ({ certifications = [] }) => {
  const validCertifications = filterValidItems(certifications);
  if (validCertifications.length === 0) return null;

  return (
    <Section title={COPIES.title}>
      <List disablePadding>
        {validCertifications.map(certification => {
          const {
            issuing_organization: organization,
            description,
            issued_date: issuedDate,
            expiry_date: expiryDate,
            credential_id: credentialId,
            license_number: licenseNumber
          } = certification;

          const formattedIssuedDate = isTruthyValue(issuedDate) && formatMonthYear(issuedDate);
          const formattedExpiryDate = isTruthyValue(expiryDate) && formatMonthYear(expiryDate);

          return (
            <ListItem key={organization} disableGutters>
              <ListItemText
                primary={
                  <>
                    {isTruthyValue(organization) && (
                      <Typography color="textSecondary">{organization}</Typography>
                    )}

                    {isTruthyValue(description) && (
                      <DescriptionText component="pre">
                        <b>{description}</b>{' '}
                        {(credentialId || licenseNumber) && ` (${credentialId || licenseNumber})`}
                      </DescriptionText>
                    )}

                    {(formattedIssuedDate || formattedExpiryDate) && (
                      <Typography color="textSecondary">{`${
                        formattedIssuedDate
                          ? `${COPIES.fields.issuedDate}: ${formattedIssuedDate}`
                          : ''
                      } ${
                        formattedExpiryDate
                          ? `/ ${COPIES.fields.expiryDate}: ${formattedExpiryDate}`
                          : ''
                      }`}</Typography>
                    )}
                  </>
                }
              />
            </ListItem>
          );
        })}
      </List>
    </Section>
  );
};
